export enum PagesType {
  HOME = 'HOME',
  PAY = 'PAY',
  CHECK_IN = 'CHECK_IN'
}
